/* eslint-disable no-console */
export class ReducerRegistry {
  constructor() {
    this.emitChange = null;
    this.reducers = {};
    this.defaultState = {};
  }

  init(store) {
    this.store = store;
  }

  getReducers() {
    return { ...this.reducers };
  }

  getDefaultStates() {
    return { ...this.defaultState };
  }

  register(name, reducer, appState = null) {
    if (process.env.NODE_ENV !== 'production')
      console.log('registering', name, 'reducer');

    this.reducers = { ...this.reducers, [name]: reducer };

    if (appState)
      this.defaultState = { ...this.defaultState, [name]: appState };

    if (this.emitChange) this.emitChange(this.getReducers());

    this.emitLazyLoadedMessage(name);
  }

  setChangeListener(listener) {
    this.emitChange = listener;
  }

  emitLazyLoadedMessage(name) {
    if (this.store) {
      this.store.dispatch({
        type: `@@registry/LAZY_LOADED_${name?.toUpperCase()}_REDUCER`,
        payload: name
      });
    }
  }
}

export default new ReducerRegistry();
